'use strict';

var _config = require('common/config');

var _config2 = _interopRequireDefault(_config);

var _merge = require('lodash/object/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// fixes exception thrown in IE
// from this: http://stackoverflow.com/questions/25754622/reveal-standalone-module-not-working
if (typeof Foundation !== 'undefined') {
    Foundation.global.namespace = '';
}

var fontCharMapDecode = function fontCharMapDecode(str) {
    var row;
    var key;
    var rows = str.split('\n');
    var chunks = {};
    for (var i = 0; i < rows.length; i++) {
        row = rows[i];
        // find the row identifier
        key = row.match(/^([a-z0-9]{4}): /)[1];
        if (key.length != 4) {
            throw new Error('Key not found');
        }
        // find the 32 bit chunks
        chunks[key] = row.match(/[a-z0-9]{8}/g);
        for (var j = 0; j < chunks[key].length; j++) {
            chunks[key][j] = parseInt(chunks[key][j], 16);
        }
        if (chunks[key].length != 8) {
            throw new Error('Row data not found');
        }
    }
    return chunks;
};

var HfReactHelper = module.exports = (0, _merge2['default'])({}, _config2['default'], {

    imgHelper: function imgHelper(input_string) {

        var domain = HfReactHelper.hfCdn;
        if (typeof location !== 'undefined') {
            domain = String(location.hostname).indexOf('hellofax') !== -1 ? HfReactHelper.hfCdn : HfReactHelper.hsCdn;
        }

        return '//' + domain + '/images/' + input_string;
    },

    urlHelper: function urlHelper(input_string, site) {
        if (site !== HfReactHelper.HfSites.SITE_CODE_HF && site !== HfReactHelper.HfSites.SITE_CODE_HS) {
            site = HfReactHelper.isHelloSign ? HfReactHelper.HfSites.SITE_CODE_HS : HfReactHelper.HfSites.SITE_CODE_HF;
        }
        return HfReactHelper.urlHelperUrl ? HfReactHelper.urlHelperUrl.replace('__site__', site) + '/' + input_string : input_string;
    },

    extend: function extend() {
        for (var i = 1; i < arguments.length; i++) {
            for (var key in arguments[i]) {
                if (arguments[i].hasOwnProperty(key)) {
                    arguments[0][key] = arguments[i][key];
                }
            }
        }
        return arguments[0];
    },

    trim: function trim(s) {
        if (s && s.length > 0) {
            for (var a = 0; a < s.length; a++) {
                if (s[a] !== ' ') {
                    break;
                }
            }
            for (var b = s.length - 1; b >= 0; b--) {
                if (s[b] !== ' ') {
                    break;
                }
            }
            return s.slice(a, b + 1);
        } else {
            return '';
        }
    },

    inArray: function inArray(elem, array) {
        if (array.indexOf) {
            return array.indexOf(elem);
        }

        for (var i = 0, length = array.length; i < length; i++) {
            if (array[i] === elem) {
                return i;
            }
        }

        return -1;
    },

    isValidEmailAddress: function isValidEmailAddress(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@\']+(\.[^<>()\[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },

    isValidPhoneNumber: function isValidPhoneNumber(number) {
        var re = /^(1[\s-]?)?[\(\[\s-]{0,2}?\d{3}[\)\]\s-]{0,2}?\d{3}[\s-]?\d{4}$/;
        return re.test(number);
    },

    /*
    * Helper function for Foundation modals - cf: http://foundation.zurb.com/sites/docs/v/5.5.3/components/reveal.html
    */
    getRevealAttachPoint: function getRevealAttachPoint(element_id, size, showCloseButton, className) {

        var attachPoint;
        var modalContainer = document.getElementById(element_id);

        if (modalContainer === null) {
            modalContainer = document.createElement('div');
            modalContainer.id = element_id;
            var sizeClass = 'm-modal-restricted-size';
            if (typeof size !== 'undefined') {
                sizeClass = 'm-modal ' + size;
            }
            modalContainer.className = 'reveal-modal ' + sizeClass;
            if (typeof className !== 'undefined') {
                modalContainer.className += ' ' + className;
            }
            modalContainer.setAttribute('data-reveal', '');
            document.body.appendChild(modalContainer);

            if (typeof showCloseButton === 'undefined' || showCloseButton !== false) {
                var closeButton = document.createElement('a');
                closeButton.className = 'close-reveal-modal m-modal--close';
                closeButton.innerHTML = '&#215;';
                modalContainer.appendChild(closeButton);
            }

            attachPoint = document.createElement('div');
            attachPoint.className = 'm-modal--container';
            modalContainer.appendChild(attachPoint);
        } else {
            attachPoint = modalContainer.getElementsByTagName('div')[0];
        }

        return attachPoint;
    },

    formatMoney: function formatMoney(amount, currency, isInCents) {

        if (isInCents === true) {
            amount = amount / 100.0;
        }

        var rounded = parseInt(amount, 10);
        var cents = parseInt((amount - rounded) * 100, 10);

        return (currency !== undefined ? currency : '') + rounded + (cents > 0 ? '.' + cents : '');
    },

    isHelloFax: function isHelloFax() {
        return !! ~location.hostname.indexOf('hellofax');
    },

    isHelloSign: function isHelloSign() {
        return !! ~location.hostname.indexOf('hellosign');
    },

    // deprecate this (CC)
    HfSites: {

        isHelloFax: function isHelloFax(siteOrSiteCode) {
            return siteOrSiteCode === HfReactHelper.HfSites.SITE_CODES[0] || siteOrSiteCode === HfReactHelper.HfSites.SITE_CODE_HF;
        },

        isHelloSign: function isHelloSign(siteOrSiteCode) {
            return siteOrSiteCode === HfReactHelper.HfSites.SITE_CODES[1] || siteOrSiteCode === HfReactHelper.HfSites.SITE_CODE_HS;
        },

        getSite: function getSite(siteCode) {
            return this['SITE_CODE_H' + siteCode];
        }
    },

    hasLocalStorage: function hasLocalStorage() {
        // in a try/catch block since this method of checking is more compatible with
        // other browsers. See http://stackoverflow.com/questions/16427636/check-if-localstorage-is-available.
        try {
            var k = '__local_storage_check__';
            localStorage.setItem(k, true);
            localStorage.removeItem(k);
            return true;
        } catch (e) {
            return false;
        }
    },

    FONT_CHAR_MAP: {
        'La Belle Aurore': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
        'Mr De Haviland': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
        'Nothing You Could Do': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffff7fff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
        'Zeyada': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
        'Dawning of a New Day': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffff7fff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
        'Herr Von Muellerhoff': fontCharMapDecode('0000: 00000000 ffffffff bfffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000'),
        'Over the Rainbow': fontCharMapDecode('0000: 00000000 ffffffff ffffffff 7fffffff 00000000 ffffffff ffffffff ffffffff\n' + '0001: 00000000 00000000 000c0000 01000000 00000000 00000000 00000000 00000000\n' + '0002: 00000000 00000000 00000000 00000000 00000000 00000000 10000040 00000000\n' + '0020: 771f07ff 06008044 80000000 00000000 00000000 00001000 00000000 00000000\n' + '0021: 00000000 00000004 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00e0: 00000001 00000000 00000000 00000000 00000000 00000000 00000000 00000000\n' + '00fb: 00000006 00000000 00000000 00000000 00000000 00000000 00000000 00000000')
    },

    // Getter to safely retrieve localStorage and avoid throwing tons of exceptions
    // in private browsing mode or when stricter security rules are in application
    getLocalStorage: function getLocalStorage() {

        try {
            if (typeof localStorage !== 'undefined') {
                return localStorage;
            }
        } catch (e) {
            if (e.name !== 'SecurityError') {
                // Only skip if it's a security error
                throw e;
            }
        }

        // Return stub
        return {
            setItem: function setItem() {},
            getItem: function getItem() {},
            removeItem: function removeItem() {}
        };
    },

    attachSessionInfoToUrl: function attachSessionInfoToUrl(url) {
        if (window.hellofaxJS) {
            url = hellofaxJS.attachSessionInfoToUrl(url);
        }
        return url;
    },

    Cookie: {
        get: function get(key) {
            var parts,
                pairs = document.cookie.split(";");
            for (var k in pairs) {
                parts = $.trim(pairs[k]).split("=");
                if (parts.shift() == key) {
                    return parts.join("=");
                }
            }
        },

        set: function set(key, value, ttl_ms, path) {
            var c = key + "=" + value;
            if (ttl_ms !== undefined) {
                var d = new Date();
                d.setTime(d.getTime() + ttl_ms);
                c += "; expires=" + d.toUTCString();
            }
            if (path === undefined) {
                path = document.location.pathname;
            }
            if (path) {
                // This way we can skip setting path by using path=null
                c += "; path=" + path;
            }
            c += "; domain=" + document.domain + ";";
            document.cookie = c;
        }
    }

});

// IE9 shim
// TODO - move this to ./shims
if (typeof window !== 'undefined' && !window.console) {
    window.console = {};window.console.log = function () {};
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/hf-react-helper.js
 ** module id = 396
 ** module chunks = 0
 **/